import React, { useContext, useEffect } from 'react';
import utils from '../utils';
import InputBox from '../InputBox';
import ModifySearchContext from '../ModifySearchContext';
import DatePicker from './DatePicker';

const SelectDate = ({
  label = 'DURING',
  value = '',
  handleChange,
  name = '',
  next = null,
  onNext = () => {},
  numberOfMonths = 2,
  renderDay,
  onFocus,
  openBox = null,
  searchButtonClicked = false,
  setsearchButtonClicked,
  maxDate,
  minDate,
  disableDates,
  destinationCity,
  listingDateData = {},
  datePicker,
  icon,
}) => {
  const { setActiveControl } = useContext(ModifySearchContext);
  useEffect(() => {
    if (openBox !== null) {
      setActiveControl(openBox);
      setsearchButtonClicked(false);
    }
  }, [openBox, searchButtonClicked]);
  const handleDateChange = date => {
    setActiveControl(next || null);
    handleChange(date);
    if (next && onNext) {
      onNext();
    }
  };
  return (
    <InputBox
      name={name}
      value={utils.getDisplayValue('datepicker', value)}
      onFocus={onFocus}
      label={label}
      icon={icon}
    >
      <DatePicker
        value={value}
        handleChange={handleDateChange}
        numberOfMonths={numberOfMonths}
        renderDay={renderDay}
        maxDate={maxDate}
        minDate={minDate}
        disableDates={disableDates}
        destinationCity={destinationCity}
        listingDateData={listingDateData}
        datePicker={datePicker}
        handleClose={() => setActiveControl(null)}
      />
    </InputBox>
  );
};

export default SelectDate;
